module.exports = __webpack_public_path__ + "img/all-cover.61de1ff9.png";